import type { ComponentProps } from "react"

const DEFAULT_FILL = "#2563EB"

function NearestNavigator(props: ComponentProps<"svg"> & { fill?: string }) {
  const { fill = DEFAULT_FILL, ...svgProps } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 48 48"
      {...svgProps}
    >
      <circle cx="24" cy="24" r="24" fill={fill} />
      <path d="M15 32 L24 14 L33 32 L24 26 Z" fill="white" />
    </svg>
  )
}

export default NearestNavigator
